require('./lbMap.scss');

const $inject = [];

const lbMap = function () {
  return {
    controller: 'lbMapController',
    controllerAs: 'vm',
    bindToController: true,
    template: require('./lbMapTemplate.html'),
    scope: {
      locations: '=',
      mapCenter: '=',
      zoomLevel: '=',
      gridSize: '='
    }
  }
};

lbMap.$inject = $inject;

export default lbMap;



// WEBPACK FOOTER //
// ./src/components/lbMap/lbMapDirective.js